export function grafiekStates() {
	var inputTool = window.innerWidth > 1024 ? "cursor" : "vinger";

	return [
		{
			state: 0,
			explain: "visible",
			explain_tekst: "Teken de lijn voor jonge kinderen met je " + inputTool,
			explain_to: 1,
			button: "hidden",
			button_tekst: "",
			button_icon: () => {
			},
			button_to: null,
			kids_line: "hidden",
			teens_line: "hidden",
			user_line: "hidden"
		},
		{
			state: 1,
			explain: "hidden",
			explain_tekst: "",
			explain_to: null,
			button: "visible",
			button_tekst: "Klaar met tekenen",
			button_icon: () => {
				return require(`../../assets/images/grafiek_1.png`);
			},
			button_to: 2,
			kids_line: "hidden",
			teens_line: "hidden",
			user_line: "visible"
		},
		{
			state: 2,
			explain: "visible",
			explain_tekst: "Het overgewicht onder jonge kinderen is licht gedaald",
			explain_to: 3,
			button: "visible",
			button_tekst: "Bekijk de lijn voor tieners",
			button_icon: () => {
				return require(`../../assets/images/grafiek_3.png`);
			},
			button_to: 4,
			kids_line: "visible",
			teens_line: "hidden",
			user_line: "visible"
		},
		{
			state: 3,
			explain: "hidden",
			explain_tekst: "",
			explain_to: null,
			button: "visible",
			button_tekst: "Bekijk de lijn voor tieners",
			button_icon: () => {
				return require(`../../assets/images/grafiek_3.png`);
			},
			button_to: 4,
			kids_line: "visible",
			teens_line: "hidden",
			user_line: "hidden"
		},
		{
			state: 4,
			explain: "visible",
			explain_tekst: "Teken de lijn voor tieners met je " + inputTool,
			explain_to: 5,
			button: "hidden",
			button_tekst: "",
			button_icon: () => {
			},
			button_to: null,
			kids_line: "hidden",
			teens_line: "hidden",
			user_line: "hidden"
		},
		{
			state: 5,
			explain: "hidden",
			explain_tekst: "",
			explain_to: null,
			button: "visible",
			button_tekst: "Klaar met tekenen",
			button_icon: () => {
				return require(`../../assets/images/grafiek_1.png`);
			},
			button_to: 6,
			kids_line: "hidden",
			teens_line: "hidden",
			user_line: "visible"
		},
		{
			state: 6,
			explain: "visible",
			explain_tekst: "Het overgewicht onder tieners is sterk gestegen",
			explain_to: 7,
			button: "hidden",
			button_tekst: "",
			button_icon: () => {
			},
			button_to: 4,
			kids_line: "hidden",
			teens_line: "visible",
			user_line: "visible"
		},
		{
			state: 7,
			explain: "visible",
			explain_tekst: 'Het verschil tussen jonge kinderen en tieners is groot, lees meer in onze <a href="https://pointer.kro-ncrv.nl/hoe-kinderen-ondanks-niet-mag-reclames-ongezond-eten-zien" target="_blank">interactive</a>',
			explain_to: 8,
			button: "visible",
			button_tekst: "Begin opnieuw",
			button_icon: () => {
				return require(`../../assets/images/grafiek_2.png`);
			},
			button_to: 4,
			kids_line: "hidden",
			teens_line: "visible",
			user_line: "hidden"
		},
		{
			state: 8,
			explain: "hidden",
			explain_tekst: "",
			explain_to: null,
			button: "visible",
			button_tekst: "Begin opnieuw",
			button_icon: () => {
				return require(`../../assets/images/grafiek_2.png`);
			},
			button_to: 4,
			kids_line: "hidden",
			teens_line: "visible",
			user_line: "hidden"
		}
	]
}
